<template>
  <div class="table_wrapper">
    <table class="table_list" ref="table">
      <slot name="header"></slot>
      <tbody class="table_list_body">
        <template v-if="currentList && currentList.length">
          <slot name="row" v-for="(rowData, index) in currentList" v-bind="{rowData, index, currentList}"></slot>
        </template>
        <template v-else>
          <tr><td :colspan="columnNum">{{emptyText}}</td></tr>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
import base from '$mixins/table/base'

export default {
  mixins: [ base ],
  props: {
    itemPerPage: {
      type: Number,
      default: Number.MAX_VALUE
    }
  }
}
</script>
